<template>
  <div id="header">
    <div class="header-container">
      <div id="header-logged-out">
        <a :href="myResourcesLink" class="link">
          <div class="logo">
            <div class="logo-text">Cambridge</div>
            <img src="../../../public/img/header/cambridge-go-logo.png" />
          </div>
        </a>
        <div v-if="!isLoggedIn">
          <ul>
            <a
              :href="$t('support.link')"
              target="_blank"
              class="link"
              rel="noopener"
            >
              <li>Support</li>
            </a>
            <a :href="$t('store.link')" target="_blank" class="link" rel="noopener">
              <li>Store</li>
            </a>
            <a v-show="!isLoggedIn" href="https://www.cambridge.org/go/login/" class="link">
              <li>Log in</li>
            </a>
          </ul>
          <v-menu id="user-menu" offset-y>
            <template v-slot:activator="{ on }">
              <button v-on="on">
                Menu
                <v-icon>mdi-menu</v-icon>
              </button>
            </template>
            <v-list>
              <v-list-item :href="$t('support.link')" target="_blank" rel="noopener">
                <v-list-item-title>Support</v-list-item-title>
              </v-list-item>
              <v-list-item :href="$t('store.link')" target="_blank" rel="noopener">
                <v-list-item-title>Store</v-list-item-title>
              </v-list-item>
              <v-list-item v-show="!isLoggedIn" href="https://www.cambridge.org/go/login/">
                <v-list-item-title>Log in</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <div class="flex-item" v-else>
          <ul class="link-list">
            <a :href="$t('store.link')" target="_blank" class="link" rel="noopener">
              <li>Store</li>
            </a>
            <li>
              <div class="menu">
                <img :src="avatar" alt="User" />
                <div class="role">{{ role }}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import cookie from 'vue-cookies'
export default {
  name: 'Header',
  data () {
    return {
      myResourcesLink: 'https://www.cambridge.org/go/myresources/',
      avatar: 'https://www.cambridgedev.org/go-qa/img/avatar.bdd19b2.svg',
      isLoggedIn: null,
      role: null,
      fullName: null
    }
  },
  created () {
    this.loadUser()
  },
  methods: {
    loadUser () {
      const user = cookie.get('checkpoints_user')
      if (user) {
        this.isLoggedIn = user.is_logged_in
        this.role = user.role
        this.fullName = user.full_name
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.v-menu__content {
  .v-list {
    .v-list-item {
      .v-list-item__icon {
        .v-icon {
          color: $black;
        }
      }
      .v-list-item__title {
        color: $primary;
      }

      &:hover {
        background: $content_sidebar_hover;
      }
    }
  }
}

#header {
  background-color: #fff;
  border-bottom-style: solid;
  border-color: #dddddd;
  border-width: 1.5px;
  width: 100%;
  height: 64px;
  position: fixed;
  z-index: 2;
  .header-container {
    padding: auto;
    max-width: 1832px;
    margin: auto;
    height: 100%;

    #header-logged-out {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-between;
      height: 100%;
      padding: 0px 16px;
      .link {
        text-decoration: none;
        .logo {
          display: flex;
          align-items: center;
          img {
            max-width: 28px;
            margin-left: 10px;
          }
          .logo-text {
            font-size: $StandardTextSize;
            letter-spacing: $LetterSpace;
            font-weight: bold;
            color: $cambridge-logo-blue;
          }
        }
      }
      ul {
        flex: 1;
        list-style: none;
        display: flex;
        justify-content: flex-end;
        padding: 0px;
        .link {
          text-decoration: none;
          li {
            padding: 10px 20px 10px 20px;
            cursor: pointer;
            color: $primary;
            font-weight: bold;
            font-size: $StandardTextSize;
            letter-spacing: $LetterSpace;
            transition: color 0.3s;
            &:hover {
              color: $secondary;
            }
          }
        }
      }
      button {
        display: none;
        color: $primary;
        font-weight: bold;
        font-size: $StandardTextSize;
        letter-spacing: $LetterSpace;
        text-transform: none;
        padding: 0px;
        outline: none;
        .v-icon {
          color: $primary;
        }
      }
    }
  }
}

.flex-item {
  display: flex;
  align-items: center;
  .link-list {
    display: flex;
    list-style: none;
    padding: 0px;
    align-items: center;
    li {
      .link {
        text-decoration: none;
        cursor: pointer;
        font-weight: bold;
        padding: 14px;
        margin-right: 10px !important;
        color: $primary;
        transition: color 0.3s;
        margin-right: 30px;
        &:hover {
          color: $secondary;
        }
      }
    }
  }
  .menu {
    display: flex;
    align-items: center;
    img {
      border-radius: 100px;
      width: 36px;
      height: 36px;
      margin-right: 8px;
      border-style: solid;
      border-width: 1px;
      border-color: #ccc;
    }
    .role {
      font-size: 14px;
      font-weight: bold;
      color: $black;
      outline: none;
      text-transform: capitalize;
    }
    .v-icon {
      color: $primary;
      font-size: 25px;
    }
  }
}

@media (max-width: 1100px) {
  #header {
    .header-container {
      #header-logged-out {
        ul {
          display: none;
        }
        button {
          display: block;
        }
      }
    }
  }
}
</style>
